import {
    BusinessDetails,
    ContactDetails,
    FooterLink,
    GoogleDetails,
    MetaTagsProps,
    SocialMediaProfilesTypes
} from "@/types";

export const BUSINESS_NAME: string = "Harris Excavation Services";
export const WEBSITE_URL: string = "https://harrisexcavation.com.au";
export const OG_PATH = `${WEBSITE_URL}/images/og/`;
export const defaultMetaTags: MetaTagsProps = {
title: `${BUSINESS_NAME} | Sydney Excavation Specialists for Residential, Commercial, and Industrial Projects`,
description: `${BUSINESS_NAME} is a Sydney-based excavation company specialising in residential, commercial, and industrial projects. Our services include mini excavation, driveway and footpath excavation, pool demolition and backfilling, site cuts, trenching, underground basements, industrial footings, soil removal and rock breaking. Trusted by builders, developers, and homeowners across Sydney for reliable, safe, and cost-effective excavation solutions.`,
keywords: "excavation sydney, mini excavation sydney, driveway excavation sydney, pool demolition sydney, trenching sydney, site cuts sydney, basement excavation sydney, footings excavation sydney, soil removal sydney, rock breaking sydney, posi track hire sydney",
url: WEBSITE_URL,
    ogImage: `${OG_PATH}img1.jpg`,
    type: "website",
}

export const socialMediaProfiles: SocialMediaProfilesTypes = {
    instaLink: "https://www.instagram.com/",
    instaHandle: "",
    instaPostsLink: "https://www.instagram.com/p/",
    tikTokLink: "https://www.tiktok.com/",
    tikTokHandle: "",
    tikTokPostsLink: "https://www.tiktok.com/",
    facebookLink: "https://www.facebook.com/",
    facebookHandle: "",
    linkedInLink: "https://www.linkedin.com/company/",
    linkedInHandle: "",
    youTubeHandle: "",
    youTubeLink: "https://youtube.com/",
}

export const contactDetails: ContactDetails = {
    contactNumberOne: "0478 782 426",
    contactNumberTwo: "",
    fax:"",
    contactEmail: "harrisexcavationservices@hotmail.com",
}

export const footerLinks: FooterLink[] | undefined = [
    {
        url: "/documents/Privacy%20Policy%20Manual-Harris%20Excavtion%20Services%20Pty%20Ltd.pdf",
        label: "Privacy Policy"
    },
    {
        url: "/documents/TOT.pdf",
        label: "Terms of Trade"
    }
];

export const googleDetails: GoogleDetails = {
    googleHandle: "",
    googleLink: "",
    googleMaps: "",
    googleReviewLink: "https://search.google.com/local/writereview?placeid=ChIJU9SiBXK9EmsRVrQ2cBp7jAs",
    googleServiceArea: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6865986.541988571!2d150.05236179999997!3d-32.8311501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12bd7205a2d453%3A0xb8c7b1a7036b456!2sHarris%20excavation%20services!5e0!3m2!1sen!2sau!4v1759371031638!5m2!1sen!2sau", //embed link
    areaServed: "Sydney",
    serviceAreaLatLong: {
        latitude: -33.9180, // Sydney
        longitude: 151.0346
    }
}

export const businessDetails: BusinessDetails = {
    branding: {
        headerLogoUrl: "/images/logos/header-logo.svg",
        footerLogoUrl: "/images/logos/footer-logo.svg",
    },
    companyData: {
        abn: "",
        address: "PO BOX 145, Greenacre NSW 2190",
        licenseNumber: "",
    },
    captchaKeys: {
        dev: "6LeDLn4UAAAAAPW2RFlXvgusfkU9e_n4Q7zFtpQj",
        prod: "6LcP3p0oAAAAAOLrgJTbudQ5pkckcNng9CJtxr1M",
    },
    address: {
        streetAddress: "123 High St",
        addressLocality: "Bankstown",
        addressRegion: "NSW",
        postalCode: "2200",
        addressCountry: "AU"
    },
    serviceAreas: [
        "Sydney CBD",
        "Inner West",
        "Eastern Suburbs",
        "Lower North Shore",
        "Upper North Shore",
        "Northern Beaches",
        "Western Sydney",
        "Southern Sydney",
        "Sutherland Shire",
        "Greater Western Sydney",
    ],
    generalServiceArea:'Sydney'
};
